import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable";
import SnackbarAlert from "../components/SnackbarAlert";
import { Box, TextField, Typography, CircularProgress, Switch, Button, Dialog, DialogTitle, DialogContent } from "@mui/material";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
export default function Review() {
    const [datasource, setDatasource] = useState([]);
    const [search, setSearch] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [imageOpen, setImageOpen] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    useEffect(() => {
        fetchStaffData();
    }, []);
    const fetchStaffData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "review";
            const response = await makeRequest("get", url);
            if (response) {
                setDatasource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const handleToggleStatus = async (item) => {
        const newStatus = item?.isActive === 0 ? 1 : 0;
        try {
            setLoading(true);
            let url = webEndPoint + "review/status/" + item.rfId;
            const payload = {
                isActive: newStatus
            };
            const response = await makeRequest("put", url, payload);
            if (response) {
                setMessage(
                    newStatus === 0 ? "Staff Enabled Successfully" : "Staff Disabled Successfully"
                );
                setSnackbar(true);
                fetchStaffData();
            }
        } catch (err) {
            console.error(err);
            setMessage("Failed to update status");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const handleViewImages = (images) => {
        setSelectedImages(Array.isArray(images) ? images : []);
        setImageOpen(true);
    };
    const filteredState = datasource?.filter((d) =>
        d?.first_name?.toLowerCase().includes(search?.toLowerCase()) || d?.staff_mobilenumber?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "User Name", "Product Name", "Rating", "Review Title", "Review Message", "Images", "Action"];
    const rows = filteredState?.map((item, index) => [index + 1, item.first_name, item.product_name, item?.rating, item?.review_title, item?.review_message,
    <Button variant="outlined" size="small" onClick={() => handleViewImages(item?.images)}>View Images</Button>,
    <Switch checked={item?.isActive === 1} onChange={() => handleToggleStatus(item)} color="success" />
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>Reviews</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search User Name" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={imageOpen} onClose={() => setImageOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>Review Images
                    <Button variant="outlined" color="error" size="small" onClick={() => setImageOpen(false)}>Close</Button>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 1 }}>
                        {selectedImages?.length > 0 ? (
                            selectedImages?.map((img, index) => (
                                <img key={index} src={img.image_url} alt={`review-${index}`} style={{ width: 150, height: 150, objectFit: "cover", borderRadius: 8, border: "1px solid #ddd" }} />
                            ))
                        ) : (
                            <Typography>No Images Available</Typography>
                        )}
                    </Box>
                </DialogContent>
            </Dialog>
            
        </Box>
    );
}